// extracted by mini-css-extract-plugin
export default {"container":"search-regions-input_container__w4Nk2","search__input":"search-regions-input_search__input__igCVA"};